// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1pC1UrRplPshWP_OcYl7n8 {\n  height: 8px !important;\n}", "",{"version":3,"sources":["webpack://src/components/atoms/logo.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB","sourcesContent":[".root {\n  height: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_1pC1UrRplPshWP_OcYl7n8"
};
export default ___CSS_LOADER_EXPORT___;
